// src/hooks/useBotStatus.ts
import { useBotConfig } from './useApi';

export const useBotStatus = () => {
  const { data: botConfigResponse, isLoading: configLoading, error: configError } = useBotConfig();

  const botConfig = botConfigResponse?.data;
  const isActive = botConfig?.status === 'online';
  
  return { 
    isLoading: configLoading, 
    isActive, 
    error: configError 
  };
};